<template>
  <v-container>
    <v-card class="mx-auto" flat>
      <v-row>
        <v-col>
          <p class="headline font-weight-bold" style="color:#AF8936; font-size: 27px !important;">
             Publicación de Sentencias
          </p>
        </v-col>
      </v-row>
      <v-divider class="mb-9"></v-divider>
      <v-alert
        v-if="message"
        border="left"
        colored-border
        color="orange"
        elevation="2"
      >
      {{message}}
      </v-alert>

      <v-dialog
        v-model="progressLoading"
        hide-overlay
        persistent
        width="300"
      >
        <v-card
          color="grey darken-2"
          dark
        >
          <v-card-text>
            Cargando Sentencia...
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
const Swal = require('sweetalert2');
  export default {
    props: ['id'],
    data: () => ({
      progressLoading: false,
    }),
    mounted(){
      this.getFile()
    },
    methods:{
      getFile(){
        this.progressLoading = true
        var toca_id = 0
        toca_id = parseInt(this.id)
        if ( toca_id != this.id ) {
          this.message = "EL DOCUMENTO NO EXITE"
          this.progressLoading = false
          return false;
        }
        this.$store.dispatch("GET_FILE", toca_id).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response[0].data], { type: 'application/pdf' }));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', toca_id +'.pdf');
          document.body.appendChild(link);
          link.click()
          this.progressLoading = false
          this.message = "EL DOCUMENTO SE HA DESCARGADO"
          this.$swal({
            title: 'Documento descargado correctamente!!!',
            icon: 'success'
          })
        })
        .catch(err => {
          this.message = "El documento NO existe !!!!"

          this.$swal({
            title: 'Error al descargar la sentencia, verifique la url.',
            icon: 'error'
          })
          this.progressLoading = false
          console.log(err);
        });
      },
    }
  }
</script>
